<template>
    <div v-if="temPermissao('p-super-admin')">
        <!-- <h4>{{ user }} - {{ idUser }}</h4> -->
        <b-container fluid>
            <b-row>
                <b-col cols="6">
                    <b-form-group label="Informe o team/empresa do usuário">
                        <b-form-select v-model="idTeams" :options="dataTeams.data.contentsTeams" value-field="id"
                            text-field="display_name" :disabled="dataTeams.length === 0" required>
                        </b-form-select>
                    </b-form-group>
                    <br>
                    <br>
                    <span v-if="idTeams" class="mp-5"> .:: Classes da escola Selecionada: {{ idTeams }}</span>

                </b-col>

            </b-row>

            <b-row v-if="idTeams">
                <b-col>

                    <table class="table striped">
                        <thead>
                            <tr>
                                <th>Id Usuário</th>
                                <th>Nome Usuário</th>
                                <th>Id Classe</th>
                                <th>Nome Classe</th>
                                <th>Id Escola </th>
                                <th>Management</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in filteredUsersClasses" :key="index">
                                <td>{{ item.user_id }}</td>
                                <td>{{ user }}</td>
                                <td>{{ item.school_class_id }}</td>
                                <td>{{ item.school_class_name }}</td>
                                <td>{{ item.school_id }}</td>
                                <td>
                                    <span
                                        style="display: inline-flex; justify-content: center; align-items: center; width: 100%; height: 100%;">

                                        <a href="javascript:void(0)">

                                            <i class="fa-solid fa-trash-xmark mr-4" style="color: red;"
                                                @click="postDataDestroy(item.user_id, item.school_id, item.school_class_id, index)"></i>
                                        </a>

                                        <a v-b-tooltip.hover.html
                                            title='<i class="fa-sharp-duotone fa-solid fa-ban" style="--fa-primary-color: #f20707; --fa-secondary-color: #f20707;"></i> <br> Não tem edição, exclua a classe, clique na lixeira, e cadastre a correta'>
                                            <i class="fa-regular fa-pencil-slash"></i>
                                        </a>

                                    </span>
                                </td>

                            </tr>
                        </tbody>
                    </table>

                </b-col>
            </b-row>

            <b-row v-if="idTeams" class="mt-5">
                <b-col cols="6">

                    <b-form-group label="Cadastrar ou Acrescentar Classes, selecione: ">
                        <b-form-select v-model="IdClassesTeams" :options="filteredClasses" value-field="id"
                            text-field="name" :disabled="dataTeams.length === 0" required>
                        </b-form-select>
                    </b-form-group>

                    <span v-if="IdClassesTeams"> item selecionado: {{ IdClassesTeams }}</span>

                </b-col>
                <b-col cols="3" class="mt-4" style="margin-top: 3px;">

                    <b-button variant="success" @click="postData(salveClasses = true)">Adicionar</b-button>
                </b-col>
            </b-row>
        </b-container>

    </div>
    <div v-else>
        <div class="container">
            <div class="text-center">
                {{ error503 }}
                <p>Você não tem permissão para visualizar este conteúdo.</p>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import ApiService from '../../common/api.service';
export default {

    name: "Associacao-user-classes",

    props: {
        user: {
            type: String,
            default: ''
        },
        idUser: {
            type: String,
            default: ''
        },

    },

    components: {},

    created() {
        this.postData()
    },

    data() {
        return {
            NamePermission: '',
            IndexPermission: '',
            salveClasses: false,

            destroyClasse: '',

            idTeams: '',
            IdClassesTeams: '',
            idSchool: '',

            dataDestroyClasses: [],

            dataTeams: {
                data: [],
            },

        }
    },

    mounted() { },

    computed: {

        permissions() {
            return this.$store.state.auth.userpermissions.permissions;
        },
        error503() {
            return (window.location.href = '/nao-autorizado');
        },
        filteredClasses() {
            // Filtra as classes baseado no idTeams selecionado
            if (this.idTeams) {
                return this.dataTeams.data.schoolClasses.filter(
                    schoolClass => schoolClass.school_id === this.idTeams
                );
            }
            return [];
        },

        filteredUsersClasses() {
            if (this.idTeams) {
                return this.dataTeams.data.joinSchoolAndUserClasse.filter(
                    schoolClass => schoolClass.school_id == this.idTeams && schoolClass.user_id == this.idUser
                );
            }
            return [];
        },

        selectedClassName() {
            // Encontra o item correspondente ao IdClassesTeams e retorna o name
            const selectedClass = this.filteredClasses.find(
                cls => cls.id === this.IdClassesTeams
            );
            return selectedClass ? selectedClass.name : 'Nenhuma selecionada';
        },
    },

    methods: {

        temPermissao(permissao) {
            return this.permissions.includes(permissao);
        },

        addItem(newItem) {
            if (newItem.school_id === this.idTeams && newItem.user_id === this.idUser) {
                this.dataTeams.data.joinSchoolAndUserClasse.push(newItem);
            }
        },

        postData() {
            const index = 0;

            const dadosParaEnviar = {
                user_id: this.idUser,
                school_id: this.idTeams,
                school_class_id: this.IdClassesTeams,
                salveClasses: this.salveClasses
            };
            ApiService.post('/v1/assocTeams', dadosParaEnviar)
                .then((response) => {
                    this.dataTeams = response;
                    if (this.salveClasses) {

                        this.addItem({
                            school_id: this.idTeams,
                            user_id: this.idUser,
                            school_class_id: this.IdClassesTeams,
                            school_class_name: this.selectedClassName,

                        });

                        Vue.swal({
                            title: 'Confirmação',
                            text: `Classe do Usuario inserido com sucesso`,
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            cancelButtonText: '',
                            allowOutsideClick: true,
                        });
                    }

                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() => {

                    this.salveClasses = false

                });
        },

        postDataDestroy(user_id, school_id, school_class_id, index) {

            console.log(user_id + ' - ' + school_id + ' - ' + school_class_id);

            ApiService.post(`/v1/assocTeam/user_id/${user_id}/school_id/${school_id}/school_class_id/${school_class_id}`, {

            })
                .then((response) => {
                    this.dataDestroyClasses = response;
                    Vue.swal({
                        title: `${this.dataDestroyClasses.data.message}`,
                        //  html: `Anote a senha gerada automaticamente em local seguro pois não poderá ver novamente. <br>Senha: ${response.data.new_user_password}`,
                        icon: 'success',
                    });

                    this.filteredUsersClasses.splice(index, 1);
                    this.$forceUpdate();
                    //  this.dataTeams.data.joinSchoolAndUserClasse = [...this.dataTeams.data.joinSchoolAndUserClasse];

                })
                .catch(function (error) {
                    console.log(error);
                    Vue.swal({
                        title: 'Ops...',
                        html: `Houve um problema ao excluir este item. Por favor, recarregue a página e tente novamente ou entre em contato com o suporte."`,
                        icon: 'error',
                    });
                })
                .finally(() => {

                });
        },

        reload() {
            location.reload();
        },
    }

}
</script>